import React from 'react';
import MultiSelect from '@src/new-components/MultiSelect';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { useTranslation } from 'react-i18next';
import { CATEGORIES } from '@src/constants/voiceCloning';

const Category = ({ handleChangeFilter, dataFilter }) => {
  const { t } = useTranslation();

  return (
    <div style={{ flex: 1 }}>
      <MultiSelect
        variant="category"
        title={
          <Typography
            variant="body-14-medium"
            color={
              dataFilter?.categories?.length
                ? COLOR.descriptionGray
                : COLOR.descriptionUpload
            }
          >
            {t('contentType')}{' '}
            {dataFilter?.categories?.length > 0 &&
              `(${dataFilter?.categories?.length})`}
          </Typography>
        }
        options={CATEGORIES?.map((item) => ({
          label: t(item?.value),
          value: item?.value,
        }))}
        value={dataFilter?.categories}
        onChange={(value) => handleChangeFilter('categories', value)}
      />
    </div>
  );
};
export default Category;
